<template>
  <div v-if="show" class="overlay" @click.stop="">
    <div class="overlay_inner channel_list scrollable_popup">
      <p class="field search-field">
        <input
            type="text"
            id="vyhledavani"
            name="vyhledavani"
            size="30"
            placeholder="Vyhledat"
            autocomplete="off"
            class="search clearable"
            v-model="filter"
        >
      </p>
      <p class="note"><translate>Specifikovat výběr</translate> {{checkedItems.length}} / {{allItems.length}}</p>
      <div class="scrollable_popup selected_stations">
        <p class="check_all">
          <input
              id="checkall"
              name="checkall"
              type="checkbox"
              v-model="checkAll"
              @input="onCheckAll"
              :disabled="disabled"
          >
          <label for="checkall" ><strong v-translate>Vybrat vše</strong></label>
        </p>
        <ul>
          <li v-for="item in filteredSelection">
            <input type="checkbox"
                   :id="item.id"
                   :value="item.id"
                   v-model="checkedItems"
                   :disabled="disabled"
            >
            <label :for="item.id">
              <span class="item_id" v-if="showIds" v-html="highlightSearchedText(item.id)"></span>
              <span class="item_label" v-html="highlightSearchedText(item.text)"></span>
            </label>
          </li>
        </ul>
      </div>
      <p class="buttons" v-if="!disabled"><input type="submit" :value="'Uložit výběr' | translate" class="btn" @click="saveSelection"></p>
      <a @click.stop="showModal(false)" class="btn btn_action btn_close" :title="$gettext('Zavřít')" v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>

import { highlightText, removeAccents } from '../../utils/helpers';

export default {
  name: "Modal",
  props: {
    searchFunction: Function,
    selectedIds: Array,
    showIds: Boolean,
    disabled: Boolean,
    hideMultiSelection: Boolean
  },
  data: function (){
    return {
      show: false,
      filter: '',
      allItems: [],
      allItemsData: {},
      checkAll: false,
      checkedItems: this.selectedIds,
    }
  },
  computed: {
    filteredSelection(){
      if(this.filter.length){
        let filter = removeAccents(this.filter.toLowerCase());
        return this.allItems.filter((item) => {
          return removeAccents(item.text.toLowerCase()).includes(filter) || item.id.toString().includes(filter);
        });
      }else{
        return this.allItems;
      }
    }
  },
  methods:{
    showModal(value){
      this.show = value;
      if(this.show){
        this.allItemsData = {};
        this.searchFunction('', !this.hideMultiSelection)
            .then(data => {
              this.allItems = data['data'];
              this.allItems.forEach(item =>{
                this.allItemsData[item.id] = item;
              })
              this.checkAll = this.checkedItems.length === this.allItems.length;
            });
      }
    },
    highlightSearchedText(text){
      return highlightText(text, this.filter);
    },
    onCheckAll(){
        this.checkedItems = [];
      if(!this.checkAll) {
        this.allItems.forEach(item => this.checkedItems.push(item.id));
      }
    },
    saveSelection(){
      let selectedData = {};
      this.checkedItems.forEach((id) => {
        selectedData[id] = this.allItemsData[id];
      })

      this.$emit('selection-complete', this.checkedItems, selectedData)
      this.showModal(false);
    }
  },
  watch:{
    checkedItems(){
      this.checkAll = this.checkedItems.length === this.allItems.length;
    },
    selectedIds(){
      this.checkedItems = this.selectedIds;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/MultiselectSearchboxModal.vue